import { FC } from 'react'
import { ErrorViewer } from 'react-common'
import { useDocTitle } from '@/features/wa/title/useDocTitle'

type ForbiddenProps = {}

const Forbidden: FC<ForbiddenProps> = () => {
  useDocTitle('pageError.code403Title')

  return <ErrorViewer code={403} showPrimaryButton={false} />
}

export default Forbidden
